/**
 * Deserializes a confirm-handshake payload.
 *
 * Format:
 * - 1 byte: version
 * - 2 bytes: kyberCiphertext length (uint16 BE)
 * - N bytes: Kyber kyberCiphertext
 * - 32 bytes: SHA-256 hash of receiver's Kyber public key
 *
 * @param buffer - The serialized payload as Uint8Array
 * @returns An object containing the deserialized version, kyberCiphertext, and kyberPublicKeyHash
 */
export function deserializeHandshakeConfirmPayload(buffer: Uint8Array): {
  version: number;
  kyberCiphertext: Uint8Array;
  kyberPublicKeyHash: Uint8Array;
} {
  if (buffer.length < 3 + 32) {
    throw new Error('Buffer too short to contain handshake confirm payload with public key hash');
  }

  const view = new DataView(buffer.buffer, buffer.byteOffset, buffer.byteLength);
  const version = view.getUint8(0);
  const ciphertextLength = view.getUint16(1, false); // big-endian

  const expectedLength = 3 + ciphertextLength + 32;
  if (buffer.length < expectedLength) {
    throw new Error(`Payload too short: expected ${expectedLength} bytes but got ${buffer.length}`);
  }

  const kyberCiphertext = buffer.subarray(3, 3 + ciphertextLength);
  const kyberPublicKeyHash = buffer.subarray(3 + ciphertextLength, expectedLength);

  return {
    version,
    kyberCiphertext,
    kyberPublicKeyHash,
  };
}